<template>
	<button type="button" @click="handleScroll()">
		<slot slot />
	</button>
</template>

<script setup>
const props = defineProps({
	id: {
		type: String,
		required: true,
	},
	target: {
		type: String,
		default: 'start',
	},
})

const handleScroll = () => {
	const element = document.getElementById(props.id)
	const offset = 60
	const top = element.getBoundingClientRect().top - offset
	window.scrollTo({ top, behavior: 'smooth' })
}
</script>
